function Footer(){
    return(
        <footer>
            <div class="footer-sec cpt-6">
                <div class="container">
                    <div class="top-footer mb-3">
                        <div class="row">
                            <div class="col-md-6 col-lg-3 mb-4 col-sm-6">
                                <div class="foot-content">
                                    <div class="footer-title">
                                        <img src="assets/img/logo/logo-2.png" alt="Image not found"/>
                                    </div>
                                    <p class="footer-des">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis </p>

                                    <div class="social">
                                        <ul class="social-ul">
                                            <li><a href="" class="social-link"><i class="icofont-facebook"></i></a></li>
                                            <li><a href="" class="social-link"><i class="icofont-twitter"></i></a></li>
                                            <li><a href="" class="social-link"><i class="icofont-linkedin"></i></a></li>
                                            <li><a href="" class="social-link"><i class="icofont-pinterest"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-4 col-sm-6">
                                <div class="foot-content">
                                    <div class="footer-title">
                                        <h3 class="f-title">About Us</h3>
                                    </div>
                                    <ul class="footer-menu">
                                        <li class="footer-list"><a href="" class="footer-link">Blog & Articles</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Vintage Stores</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Trekking</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Sightseeing</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Tours</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-4 col-sm-6">
                                <div class="foot-content">
                                    <div class="footer-title">
                                        <h3 class="f-title">Information</h3>
                                    </div>
                                    <ul class="footer-menu">
                                        <li class="footer-list"><a href="" class="footer-link">Protocol Explore</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">System Token</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Otimize Time</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Visual Checking</a></li>
                                        <li class="footer-list"><a href="" class="footer-link">Fadeup System</a></li>
                                        <li class="footer-list"><a href="" class="footer-link"> Activity Log</a></li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-3 mb-4 col-sm-6">
                                <div class="foot-content">
                                    <div class="footer-title">
                                        <h3 class="f-title">Newsletter</h3>
                                    </div>
                                    <p class="footer-des">Fill their seed open meat. Sea you great Saw image stl</p>

                                    <form action="">
                                        <input type="text" class="form-control mb-3" placeholder="Email" />
                                        <button type="submit" class="custom-btn"><span>SUBSCRIBE</span></button>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="copy-right">
                        <p class="copy-text">Copyright 2021, Devinigne All Rights Reserved.</p>
                        <ul class="f-foot-ul">
                            <li><a href="">About us</a></li>
                            <li><a href="">Service</a></li>
                            <li><a href="">Privacy Policy</a></li>
                            <li><a href="">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>

    )
}
export default Footer;